import { always, equals, ifElse } from 'ramda';

export const styleWhen = (pred, fn) => ifElse(pred, fn, always(''));

export const styleWhenTrue = fn => styleWhen(equals(true), fn);

export const styleWhenTrueOtherwise = (fn, otherwise) => ifElse(equals(true), fn, otherwise);
